import React, { Component } from 'react'
import classes from './About.module.css';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";
// import { useGlobalContext } from '../context/context';
// import {Switch} from '@material-ui/core';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import {makeStyles} from '@material-ui/core';

const useStyles=makeStyles({
    switch:{
        marginRight:50,
        display:'flex',
        justifyContent:'flex-end',
        marginTop:50,
    }
})

function About() {
    // const classe= useStyles();
    // const {isSwitch,changeSwitch}= useGlobalContext();
   
        return (<>
            <div className={classes.box} id="about">
            {/* <FormControlLabel className={classe.switch} control={<Switch checked={isSwitch} onChange={changeSwitch} name="checkedB" color="primary"/>} label="View In Dark Mode" /> */}
                <ScrollAnimation offset={0} animateIn="fadeInLeft" duration={2.4} animateOnce={true} initiallyVisible={true}>
                    <span className={classes.head}>ABOUT ME</span>
                    
                    <h2 className={classes.heading}>Who Am I?</h2>
                    <div className={classes.About}>
                        <p >Hi! My name is <b>HARSH SWAMI</b> and I am currently working as Backend Developer Engineer at <a target="_blank" href="https://www.ril.com/"><b>Realiance Jio</b></a>. I completed my Bachelor's in Electronics and Communication Engineering from National Institute of Technology, Goa. I began my Journey of Coding just 1 year back when I completed my college </p>
                        <p className={classes.br}>I have Hands on experience with NodeJS, express and MongoDB and project experince with ReactJS. I love exploring new technologies and being a practitioner. 
                        </p>
                    </div>
                </ScrollAnimation>
            </div>
            </>
        )
    }

export default About;